import { Directive, ElementRef, EventEmitter, Output, AfterViewInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({
  selector: '[deferLoad]',
  standalone: true
})
export class DeferLoadDirective implements AfterViewInit {
  @Output() deferLoad = new EventEmitter<void>();

  constructor(
    private el: ElementRef,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngAfterViewInit(): void {
    // Skip on server - IntersectionObserver requires browser DOM
    if (!isPlatformBrowser(this.platformId)) {
      // On server, emit immediately to load content
      this.deferLoad.emit();
      return;
    }

    const element = this.el.nativeElement;

    if (!element) return;

    // Check if IntersectionObserver is available (polyfill may not be loaded yet)
    if (typeof IntersectionObserver === 'undefined') {
      // Fallback: emit immediately if IntersectionObserver not available
      this.deferLoad.emit();
      return;
    }

    const observer = new IntersectionObserver(
      ([entry], observerInstance) => {
        if (entry.isIntersecting) {
          this.deferLoad.emit();
          observerInstance.unobserve(entry.target); // load only once
        }
      },
      {
        root: null,
        threshold: 0.1
      }
    );

    observer.observe(element);
  }
}
